import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { Subscription } from 'rxjs';
import { MyDocsService } from '../../../service/mydocs.service';
import { MyDocsModel } from '../../../models/upload/mydocs.model';
import { NotificationService } from '../../../service/notification.service';
import { NotificationType } from '../../../enum/notification-type.enum';
import { TableColumn } from '../../table/TableColumn';
import { ExportExcelService } from 'src/app/service/export-excel.service';

@Component({
  selector: 'app-my-docs',
  templateUrl: './my-docs.component.html',
  styleUrls: ['./my-docs.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})

export class MyDocsComponent implements OnInit {

  public myDocsModel = new MyDocsModel();

  public showLoading: boolean;
  private subscriptions: Subscription[] = [];
  public refreshing: boolean;
  public loggedinUser: string = '';

  mySupDocsData: MyDocsModel[] = [];
  myTeamDocsData: MyDocsModel[] = [];
  excelMySupDocsData: MyDocsModel[] = [];
  excelMyTeamDocsData: MyDocsModel[] = [];

  public dataSource = new MatTableDataSource<MyDocsModel>();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('TABLE') table: ElementRef;

  public displayedColumns = ['doc_name', 'doc_desc', 'status', 'view', 'download'];

  columnsExcelData: any;
  dataForExcelTeam = [];
  dataForExcelSup = [];
  ordersTableExcelHeaderColumnsTeam: TableColumn[];
  ordersTableExcelHeaderColumnsSup: TableColumn[];

  // GRID FRAMEWORK
  ordersTableColumns1: TableColumn[];
  ordersTableColumns2: TableColumn[];
  columnsData: any;
  actions: any;
  loginUser: string = "";

  public isChecked: boolean = false;
  public isSubmit: boolean = false;
  public isApproved: boolean = false;
  public approvedStatus: string = "Pending";
  public src: any;
  public docid: number = 0;
  public document_name: string;
  public document_content: string;


  constructor(private httpService: HttpClient, private myDocsService: MyDocsService,
    public ete: ExportExcelService, private authGaurdService: AuthGaurdService, private notificationService: NotificationService) { }

  ngOnInit(): void {
    this.loggedinUser = this.authGaurdService.loginUser();
    this.loginUser = localStorage.getItem('CURRENT_USER_NAME_SESSION');
    console.log(' login name ', this.loggedinUser);
    this.getMySupDocsList();

    this.initializeColumns();

  }

  doSubmit() {
    console.log("doSubmit()");
    if (this.isChecked == true && this.isSubmit == false) {
      this.notificationService.sendNotification(NotificationType.ERROR, `You forget to Submit the Document`);
    }
  }

  getCheckBox(event: any) {
    this.isChecked = event.target.checked;
  }

  showPdf(comm_doc: string, doc_name: string) {
    console.log("called showPdf");
    //console.log("comm_doc value ==== "+atob(comm_doc));
    //console.log("comm_doc encode value ==== "+encodeURI(comm_doc));
    let pdfWindow = window.open("");
    pdfWindow.document.write("<html<head><title>" + doc_name + "</title><style>body{margin: 0px;}iframe{border-width: 0px;}</style></head>");
    pdfWindow.document.write("<body><embed width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(comm_doc) + "#toolbar=0&navpanes=0&scrollbar=0'></embed></body></html>");
  }

  downloadPdf(comm_doc: string, doc_name: string) {
    console.log("called downloadpdf");
    const linkSource = 'data:application/pdf;base64,' + comm_doc;
    const downloadLink = document.createElement("a");
    const fileName = doc_name;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  popDownload() {
    console.log("called popDownload()");
    const linkSource = 'data:application/pdf;base64,' + this.document_content;
    const downloadLink = document.createElement("a");
    const fileName = this.document_name;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  popPdf(comm_doc: any, doc_name: string) {
    console.log("popPdf called");
    console.log(comm_doc);
    console.log(doc_name);

    this.src = this._base64ToArrayBuffer(comm_doc);
    console.log(this.src);
    this.clickButton('openNameEdit');
  }

  _base64ToArrayBuffer(base64) {
    var binary_string = base64.replace(/\\n/g, '');
    binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  

  public submitStatus(status: string): void {
    console.log(status);
    console.log(localStorage.getItem('CURRENT_USER_NAME_SESSION'));
    this.isSubmit = true;
    if (this.isChecked === true) {
      const formData = this.myDocsService.createForm(this.docid, status);
      this.myDocsService.submitStatus(formData).subscribe(
        (response: MyDocsModel) => {
          this.clickButton('closeEditFiledNameModalButton');
          this.getMySupDocsList();
          // this.getEmpDocsList();
          var statusmsg: any;
          statusmsg = status + "successfully";
          this.notificationService.sendNotification(NotificationType.SUCCESS, statusmsg);
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      );
      this.isChecked = false;
    }

    else {
      this.notificationService.sendNotification(NotificationType.ERROR, `Please check the acknowledgement`);
    }
  }

  public getMySupDocsList(): void {
    console.log("called getMyDocsList");
    this.refreshing = true;
    this.myDocsService.getSupDocsList(localStorage.getItem('CURRENT_EMPLOYEEID_SESSION')).subscribe(
      (response: MyDocsModel[]) => {
        //this.dataSource.data = response as MyDocsModel[];
        this.mySupDocsData = response;
        this.excelMySupDocsData = JSON.parse(JSON.stringify(response));
        // console.log(JSON.stringify(this.excelMySupDocsData));
        this.mySupDocsData = this.mySupDocsData.sort((a, b) => (a.doc_name < b.doc_name) ? -1 : 1);
        this.refreshing = false;

      }, (errorResponse: HttpErrorResponse) => {
        this.refreshing = false;
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  public getEmpDocsList(): void {
    console.log("called getEmpDocsList");
    this.myDocsService.getEmpDocsList(localStorage.getItem('CURRENT_EMPLOYEEID_SESSION')).subscribe(
      (response: MyDocsModel[]) => {
        //this.dataSource.data = response as MyDocsModel[];
        this.myTeamDocsData = response;
        this.excelMyTeamDocsData = JSON.parse(JSON.stringify(response));
        //console.log("myDocs" + JSON.stringify(this.excelMyTeamDocsData));
        this.myTeamDocsData = this.myTeamDocsData.sort((a, b) => (a.doc_name < b.doc_name) ? -1 : 1);

      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }

  initializeExcelHeaders(): void {
    console.log("called initializeExcelHeaders");
    this.httpService.get('../../../assets/json/excelHeaders.json').subscribe(
      data => {
        this.columnsExcelData = data;
        this.ordersTableExcelHeaderColumnsTeam = this.columnsExcelData.myTeamDocs;
        this.ordersTableExcelHeaderColumnsSup = this.columnsExcelData.mySupDocs;
        this.getEmpDocsList();
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }

  exportSupExcel() {
    console.log("exportSupExcel called");
    // console.log(this.excelMySupDocsData);
    for (let js of this.excelMySupDocsData) {
      delete js.id;
      delete js.comm_doc_str;
      delete js.editMode;
      delete js.created_dt;
      delete js.comm_doc;
      delete js.comm_plan_id;
      delete js.user_type;
      delete js.effective_dt;
      delete js.employeeId;
      delete js.employeeName;
      delete js.employeesList;
      delete js.created_by;
      delete js.selected;
      delete js.updated_by;
      delete js.updated_dt;
      delete js.comment;
      delete js.sc_emp_id;
      delete js.status;
    }
    this.dataForExcelSup = [];
    let reportData = null;
    this.excelMySupDocsData.forEach((row: any) => {
      this.dataForExcelSup.push(Object.values(row));
    })
     reportData = {
      title: 'MyDocs',
      data: this.dataForExcelSup,
      headers: Object.keys(this.ordersTableExcelHeaderColumnsSup[0])
    }
    this.ete.exportExcel(reportData);
  }

  exportTeamDocsExcel() {
    console.log("exportTeamDocsExcel called");
    //console.log(this.excelMyTeamDocsData);
    for (let js of this.excelMyTeamDocsData) {
      delete js.id;
      delete js.comm_doc_str;
      delete js.editMode;
      delete js.created_dt;
      delete js.comm_doc;
      delete js.comm_plan_id;
      delete js.comm_plan_desc;
      delete js.user_type;
      delete js.effective_dt;
      delete js.employeeId;
      delete js.employeesList;
      delete js.created_by;
      delete js.selected;
      delete js.updated_by;
      delete js.updated_dt;
      delete js.uploadedDt;
      delete js.comment;
      delete js.status;
      delete js.sc_emp_id;
    }
    this.excelMyTeamDocsData.forEach((row: any) => {
      this.dataForExcelTeam.push(Object.values(row));
    })
    let reportData = {
      title: 'MyTeamDocs',
      data: this.dataForExcelTeam,
      headers: Object.keys(this.ordersTableExcelHeaderColumnsTeam[0])
    }
    this.ete.exportExcel(reportData);
  }





  // GRID FRAMEWORK

  rowAction(row: any) {
    console.log(" row: ", row.row);
    if (row.value === 'View') {
      this.popPdf(row.row.comm_doc_str, row.row.doc_name);
      this.docid = row.row.id;
      //this.isActive=true;
      this.document_content = row.row.comm_doc_str;
      this.document_name = row.row.doc_name;
      this.isChecked = false;
      this.approvedStatus = row.row.approved_status;
      console.log(this.approvedStatus);

      if (this.approvedStatus === "Approved") {
        this.isApproved = false;
        console.log(this.isApproved);
      } else {
        this.isApproved = true;
      }

      this.ngOnInit();
    }
    if (row.value === 'Download') {
      this.downloadPdf(row.row.comm_doc_str, row.row.doc_name);
    }
  }

  rowTeamAction(row: any) {
    // console.log(" row ....", row.row.id, "=== val  ", row.value);
    if (row.value === 'View') {
      this.showPdf(row.row.comm_doc_str, row.row.doc_name);
    }

    if (row.value === 'Download') {
      this.downloadPdf(row.row.comm_doc_str, row.row.doc_name);
    }
  }

  private clickButton(buttonId: string): void {
    document.getElementById(buttonId).click();
  }

  initializeColumns(): void {
    console.log("called initializeColumns function")
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.ordersTableColumns2 = this.columnsData.myTeamDocs;
        this.ordersTableColumns1 = this.columnsData.supDocs;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
    this.actions = [
      {
        name: 'View',
        dataKey: 'fas fa-eye primary f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-danger'
      },
      {
        name: 'Download',
        dataKey: 'fas fa-download success f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-danger'
      }
    ]
    this.initializeExcelHeaders();
  }
}
